<template>

  <div>
    <div class="common-form">活动商品</div>

    <el-form-item label="商品管理" prop="product_list" :rules="rulesProduct">
      <el-button icon="el-icon-plus" @click="changeProduct(form.product_list)">选择商品</el-button>
 
      <div class="pt16">
        <el-table size="mini" :data="form.product_list" :span-method="objectSpanMethod" border style="width: 100%;">
          
          <el-table-column label="商品名称" width="300">
            <template slot-scope="scope">
              <p class="text-ellipsis-2">{{ scope.row.product_name }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="product_price" label="售价"></el-table-column>
         
          <el-table-column fixed="right" label="操作" :width="type == 'edit' ? 90 : 60">
            <template slot-scope="scope">
              <el-button @click="deleteClick(scope.$index, true)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>

    <!--商品选择-->
    <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="true" @closeDialog="closeDialogFunc"></Product>

   </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import Product from '@/components/product/Product.vue';
import { mergeTable } from '@/utils/table.js';
export default {
  components: {
    /*选择商品组件*/
    Product,
  },
  data() {

    /*验证公司名称*/
    const validatorProduct = (rule, value, callback) =>{
    	if(value.length<1){
    		return callback(new Error('请选择商品'));
    	}else{
        callback();

    	}
    };

    return {
      /*是否打开选择商品*/
      isproduct: false,
      /*产品去重*/
      excludeIds: [],
      /*查询规格当前商品*/
      curProduct: {},
      /*当前的角标索引*/
      curIndex: -1,
      /*验证商品*/
      rulesProduct:[{ validator:validatorProduct, required: true, trigger: 'blur' }]
    };
  },
  props: {
    form: Object,
    type: String
  },
  created() {
  },
  methods: {
    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_id);
      });
      this.excludeIds = arr;
      this.isproduct = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e) {
      let self = this;
      self.isproduct = false;
      if (e.type == 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            product_name: item.product_name,
            product_id: item.product_id,
            multigroup_product_id: 0,
            product_price: item.product_price,
            stock_num: item.product_stock,
            tempProduct: true,
            is_delete: 0,
          };
          arr.push(obj);
        }
        self.form.product_list = self.form.product_list.concat(arr);
        self.form.product_list = mergeTable(this.form.product_list);
      }
    },
    /*删除*/
    deleteClick(e, isType) {
      let curItem=this.form.product_list[e];
  
      if (isType) {
        
        for (let i = 0; i < this.form.product_list.length; i++) {
          let item = this.form.product_list[i];
          if (curItem.product_id == item.product_id) {
            if (this.type == 'edit' && e.tempProduct != true) {
              let multigroup_product_id=item.multigroup_product_id;
              this.form.product_del_ids.push(multigroup_product_id);
            }
            this.form.product_list.splice(i, 1);
            i--;
          }
        }
      }
      this.form.product_list = mergeTable(this.form.product_list);
    },

    /*表格合并行*/
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 6 || columnIndex === 7 || columnIndex === 8 || columnIndex === 9) {
        if (row.rowSpan != null) {
          return {
            rowspan: row.rowSpan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

  }
};
</script>

<style lang="scss">
.spec-min-box > i {
  position: absolute;
  right: 0;
  font-size: 16px;
  cursor: pointer;
}
.spec-min-box .el-icon-close {
  top: 0;
  color: red;
  visibility: hidden;
}
td:hover .spec-min-box .el-icon-close {
  visibility: visible;
}
.spec-min-box .el-icon-caret-right {
  bottom: 0;
  transform: rotate(45deg);
  color: #3a8ee6;
}
.el-form-item.is-error .active-all-set .el-input__inner,
.el-form-item.is-error .isvalid .el-input__inner
{border-color: #C0C4CC;}
</style>



// WEBPACK FOOTER //
// src/views/plus/multigroup/active/part/Product.vue